import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { mapUploadProgress } from 'app/_utils/helpers';

@Injectable()
export class S3Service {

  constructor(
    protected http: HttpClient,
  ) { }

  putObject(signedUrl, file): Observable<any> {
    const contentType = file?.type || 'application/octet-stream';
    const headers = new HttpHeaders({ 'Content-Type': contentType });
    return this.http.put<any>(signedUrl, file, {
      headers,
      reportProgress: true,
      observe: 'events',
      responseType: 'text' as 'json',
    }).pipe(mapUploadProgress, filter(x => x !== undefined));
  }
}
